import type { ReactNode } from 'react'
import { WarningIcon } from './WarningIcon'

/** The prototype's `.warn-card` (subscription-portal.html): an amber wash and
 * border that stay the same in both themes, the warning triangle, and text
 * in `--warn-fg` with `<strong>` in `--warn-fg-strong` — the per-theme pair
 * that keeps the sentence evenly legible on the wash (§18a-fg). Shared by the
 * purchase confirmation (MS-820) and the "Confirm change" modal (MS-822). */
export function WarnCard({
  children,
  iconSize = 18,
  className = '',
}: Readonly<{ children: ReactNode; iconSize?: number; className?: string }>) {
  return (
    <div
      data-testid="warn-card"
      className={`flex gap-[11px] items-start bg-[var(--warn-card-bg)] border border-[var(--warn-card-border)] rounded-lg px-3.5 py-3 text-[12.5px] leading-[1.6] text-[var(--warn-fg)] [&_strong]:text-[var(--warn-fg-strong)] ${className}`}
    >
      <WarningIcon size={iconSize} stroke="var(--sim)" className="shrink-0 mt-px" />
      <div>{children}</div>
    </div>
  )
}
